import React from 'react';
import Toggle from 'components/toggle';

export default function UserProfileToggle({ checked, label, name, onChange }: UserProfileToggleProps) {
  return (
    <div className="d-flex form-group">
      <Toggle
        checked={checked}
        theme="buildout"
        onChange={onChange}
      />
      <span className="ml-3">{label}</span>
      <input
        name={name}
        type="hidden"
        value={String(checked)}
      />
    </div>
  );
}

type UserProfileToggleProps = {
  checked: boolean;
  label: string;
  name: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};
